import * as dashboardConfigService from "@hub/dashboard/src/services/dashboard-config.service"

export default {
  handleChangeFilters({ commit }, { filters, activeTabId }) {
    commit("setFilters", filters)
    commit("resetInactiveTabs", activeTabId)
  },

  async fetchDashboardConfig({ commit }) {
    const config = await dashboardConfigService.fetchDashboardConfig()
    commit("setDashboardConfig", config)
    return config
  }
}
